import { render, staticRenderFns } from "./DocumentPrintPage.vue?vue&type=template&id=b837933e&scoped=true"
import script from "./DocumentPrintPage.vue?vue&type=script&lang=js"
export * from "./DocumentPrintPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintPage.vue?vue&type=style&index=0&id=b837933e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b837933e",
  null
  
)

export default component.exports